export default function EyeSvg() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      id="eye-light"
      shapeRendering="geometricPrecision"
      textRendering="geometricPrecision"
      viewBox="0 0 390.97 232.13">
      <style>
        {
          "@keyframes eye-light-u-c_ts__ts{0%,to{transform:translate(195.487471px,116.060005px) scale(1,0)}2.222222%,97.777778%{transform:translate(195.487471px,116.060005px) scale(1,1)}}"
        }
      </style>
      <g
        style={{
          animation:
            "eye-light-u-c_ts__ts 4500ms linear infinite normal forwards",
        }}
        transform="translate(195.487 116.06)">
        <g id="eye-light-u-c" transform="translate(-195.48 -116.06)">
          <path
            id="eye-light-s-path1"
            fill="#ede9e4"
            strokeWidth={0}
            d="m386.69 105.72-45.28-45.28c-80.59-80.59-211.25-80.59-291.84 0L4.28 105.72c-5.71 5.71-5.71 14.97 0 20.68l45.28 45.28c80.59 80.59 211.25 80.59 291.84 0l45.28-45.28c5.71-5.71 5.71-14.97 0-20.68Zm-191.17 91.11c-44.63 0-80.8-36.18-80.8-80.8s36.18-80.8 80.8-80.8 80.8 36.18 80.8 80.8-36.18 80.8-80.8 80.8Z"
          />
          <circle
            id="eye-light-s-circle1"
            r={44.3}
            fill="#ede9e4"
            strokeWidth={0}
            transform="translate(195.49 116.04)"
          />
        </g>
      </g>
    </svg>
  );
}
